import { Card, CircularProgress, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useGetProjectQuery, useGetProjectWhoAvailableQuery } from "../../../../../../api/projects";
import { NotFound } from "../../../../../ui-kit/NotFound";

export const WhoAvailable = () => {
    const { slug } = useParams<{ slug: string }>()
    const { data: project } = useGetProjectQuery(slug ?? "", { skip: !slug })
    const projectId = project?.id
    const {
        data,
        isLoading,
        isError,
    } = useGetProjectWhoAvailableQuery(
        { projectId: projectId ?? 0 },
        { skip: !projectId }
    )

    if (isLoading) {
        return (
            <Stack alignItems="center" justifyContent="center" height="100%">
                <CircularProgress />
            </Stack>
        )
    }

    if (isError) return <NotFound text="Не удалось загрузить данные" />

    const list = data?.whoAvailable ?? []
    if (!list.length) return <NotFound text="Данные не заполнены" />

    return (
        <Stack direction="column" gap={{ xs: 2.5, sm: 2 }}>
            {list.map((item, index) => (
                <Card variant="primaryAdaptiveCard" sx={{ overflowWrap: 'anywhere' }} key={`${item.title}-${index}`}>
                    <Typography 
                        variant="black-16-semiBold" 
                        component="div"
                        mb={{ xs: 0.5, sm: 1}}
                    >
                        {item.title}
                    </Typography>
                    <Typography variant="body1">{item.description}</Typography>
                </Card>
            ))}
        </Stack>
    )
};
